<template>
  <FichaClinicaForm
    ref="form"
    title="Alguns dados sobre você"
    subtitle="Informe alguns de seus dados, sendo o mais preciso possível. Somente você e seu/sua médico(a) terão acesso a essas informações"
    :perguntas="perguntas"
    @on-submit="submit"
    v-model="respostas"
  />
</template>

<script>
import { mapActions } from 'vuex'
const FichaClinicaForm = () => import('@/modules/FichaClinica/FichaClinicaForm')

export default {
  components: {
    FichaClinicaForm
  },
  computed: {
    perguntas() {
      return this.$store.getters['fichaClinica/perguntasPorTipo'](null)
    },
    respostas: {
      get() {
        return this.$store.state.fichaClinica.respostas
      },
      set(value) {
        this.$store.commit('fichaClinica/SET_RESPOSTAS', value)
      }
    }
  },
  methods: {
    ...mapActions('fichaClinica', ['finalizarFichaClinica']),

    async submit() {
      if (!this.$refs.form.validate()) return

      this.$showLoading()
      const success = await this.finalizarFichaClinica()
      this.$hideLoading()

      if (success) {
        this.$router.push('assinatura')
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
</script>
